import { useState, useRef, useEffect } from "react";
import "../styling/Account.css";
import logo from "../images/logo.webp";
import defaultPic from "../images/defaultPic.svg";
import { FaDatabase, FaUpload } from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { PiLinkBold } from "react-icons/pi";
import { FaPen } from "react-icons/fa";
import { ImDownload3 } from "react-icons/im";
import ProductModal from "./modals/ProductModal";
import ColorPicker from "./ColorPicker";
import axios from "axios";
import { useSelector } from "react-redux";
import { useProfile } from "../ProfileContext";
import CancelMembershipModal from "./modals/CancelMembershipModal";

import { FaUserCircle } from "react-icons/fa";


const CompanyInfo = ({ onClickAccountInfoButton, initialSelected }) => {
  const { 
    profileImage, setProfileImage, 
    brandLogo, setBrandLogo, 
    companyData, setCompanyData 
  } = useProfile(); 

  const user = useSelector((state) => state.auth.user);
  const id = user?.businessId;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [AccountId, setAccountId] = useState(null);
  const [bankDetails, setBankDetails] = useState(null);

  const [billingInfo, setBillingInfo] = useState({
    subscription: null,
    paymentMethod: null,
    invoices: []
  });
  const [isBillingLoading, setIsBillingLoading] = useState(true);

  // --- NEW UNIFIED BILLING FETCH ---
  useEffect(() => {
    const fetchBillingData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/business-user/billing-info`,
          { withCredentials: true }
        );
        setBillingInfo(res.data.data);
      } catch (err) {
        console.error("Error fetching billing data:", err);
      } finally {
        setIsBillingLoading(false);
      }
    };
    
    // Only fetch if they have a Stripe Customer ID
    if (id) {
      fetchBillingData();
    }
  }, [id]);

  console.log("Stripe Billing Info Check:", billingInfo);

  const fetchBusinessInfo = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/businessInfo/${id}`,
        { withCredentials: true }
      );
      
      // THE FIX: Extract the nested "data" object!
      const payload = res.data.data; 
      const biz = payload?.business; 
      
      // 1. Update Images in Context
      if (payload?.brandLogoUrl) setBrandLogo(payload.brandLogoUrl); 
      if (payload?.profileImageUrl) setProfileImage(payload.profileImageUrl); 
      
      // 2. Update Company Data in Context
      setCompanyData({
        name: biz?.name || "",
        website: biz?.website || "",
        email: biz?.email || "", 
        phone: biz?.phone || "",
        street: biz?.street || "",
        cityState: biz?.cityState || "",
        zip: biz?.zip || "",
      });

      // 3. Set the Stripe Account ID for the Bank Info section
      setAccountId(biz?.stripeAccountId);

    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setLoading(false); // Stop the loading flicker
    }
  };

  useEffect(() => {
    // Only fetch if context is empty to prevent the "reloading" flicker
    if (id && !companyData.name) { 
      fetchBusinessInfo();
    } else {
      setLoading(false); // Data is already in context
    }
  }, [id]);


  const fetchBusinessAccountDetails = async () => {

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/retrieve-standard-account/${AccountId}`,
        { withCredentials: true }
      );
      setBankDetails(res?.data);
      console.log("Bank Details:", res?.data);

    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (id && !companyData.name) {
  //     fetchBusinessInfo();
  //   }
  // }, [id]);

  

  const companyInfo = data?.business;

  useEffect(() => {
    if (data) {
      console.log(data);
      setCompanyData({
        name: companyInfo?.name || "",
        website: companyInfo?.website || "",
        email: companyInfo?.email || "",
        phone: companyInfo?.phone || "",
        street: companyInfo?.street || "",
        cityState: companyInfo?.cityState || "",
        zip: companyInfo?.zip || "",
        cardNo: companyInfo?.cardNo || "",
      });

      console.log("Fetching data.....");

      setAccountId(data?.business?.stripeAccountId);

    }
  }, [data]);

  useEffect(() => {
    if (AccountId) {
      fetchBusinessAccountDetails();
    }
  }, [AccountId]);



  const [bankData, setBankData] = useState(null);
  useEffect(() => {
    if (bankDetails) {
      setBankData({
        businessType: bankDetails?.business_info?.business_type || "",
        bankAccNo: bankDetails?.bank_account?.last4 || "",
        cardNo: bankDetails?.card?.last4 || "",
        businessOwner: bankDetails?.business_info?.business_owner || "",
      });
    }
  }, [bankDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCompanyData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/update-business`,
        {
          ...companyData,
          businessId: id,
        },
        { withCredentials: true }
      );
      if (res.status !== 200) throw new Error("Update failed");
      alert("Details updated successfully!");
    } catch (err) {
      console.error(err);
      alert("Error updating details.");
    }
  };

  const [isPrimaryPickerVisible, setIsPrimaryPickerVisible] = useState(false);
  const [selectedButton, setSelectedButton] = useState(initialSelected);
  const [isSecondaryPickerVisible, setIsSecondaryPickerVisible] =
    useState(false);
  const [primaryColor, setPrimaryColor] = useState("#1C1154");
  const [secondaryColor, setSecondaryColor] = useState("#ffffff");

  useEffect(() => {
    const fetchBusinessBranding = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/client/get-branding`,
          {
            businessId: id,
          },
          { withCredentials: true }
        );

        const { primaryColor, secondaryColor } = response.data;
        setPrimaryColor(primaryColor);
        setSecondaryColor(secondaryColor);
      } catch (error) {
        console.log("Error fetching branding data: ", error);
      }
    };

    fetchBusinessBranding();
  }, []);

  const [tempColor, setTempColor] = useState("green");

  const profileInputRef = useRef(null);
  const logoInputRef = useRef(null);

  const bankRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === "#bank-info") {
      bankRef.current?.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  const teamRef = useRef(null);

  useEffect(() => {
    const scrollAndAddRow = () => {
      if (window.location.hash === "#team-members" && teamRef.current) {
        // 1. Scroll to the element
        teamRef.current.scrollIntoView({ behavior: "auto", block: "center" });

        // 2. Add a new row
        handleAddNewRow(); // make sure this is defined and doesn't throw

        // 3. Remove the hash from the URL
        window.history.replaceState(null, "", window.location.pathname);
      }
    };

    // Wait until after rendering is settled
    const timer = setTimeout(scrollAndAddRow, 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setSelectedButton(initialSelected);
  }, [initialSelected]);

  const handleProfileButtonClick = () => {
    // Programmatically click the hidden file input
    profileInputRef.current.click();
  };

  const handleBrandLogoButtonClick = () => {
    logoInputRef.current.click();
  };

  const handleProfileImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("profilePic", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/upload-profile`,
        formData,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setProfileImage(response.data.profilePic);
    } catch (error) {
      console.error("Error uploading profile image:", error);
    }
  };

  const handleBrandLogoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
  
    const formData = new FormData();
    formData.append("brandLogo", file);
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/business/upload-logo`,
        formData,
        {
          withCredentials: true,
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      
      // MATCH THE BACKEND KEY: use response.data.brandLogo
      if (response.data.brandLogo) {
        setBrandLogo(response.data.brandLogo);
        alert("Logo updated successfully!");
      }
      
      // Refresh business info to ensure other fields stay in sync
      fetchBusinessInfo();
    } catch (error) {
      console.error("Error uploading brand logo:", error);
    }
  };

  const handleButtonClick = (buttonType) => {
    setSelectedButton(buttonType);
    onClickAccountInfoButton(buttonType); // Send data to parent
  };

  const togglePrimaryPicker = () => {
    setIsPrimaryPickerVisible(!isPrimaryPickerVisible);
    setTempColor(primaryColor);
  };

  const toggleSecondaryPicker = () => {
    setIsSecondaryPickerVisible(!isSecondaryPickerVisible);
    setTempColor(secondaryColor);
  };

  const handleCancel = () => {
    setIsPrimaryPickerVisible(false);
    setIsSecondaryPickerVisible(false);
  };

  const handleChoose = async (selectedColor, type) => {
    if (type === "primary") {
      setPrimaryColor(selectedColor);
      setIsPrimaryPickerVisible(false);
      // Call API to set the primary color
      await setBranding({ primaryColor: selectedColor });
    } else if (type === "secondary") {
      setSecondaryColor(selectedColor);
      setIsSecondaryPickerVisible(false);
      // Call API to set the secondary color
      await setBranding({ secondaryColor: selectedColor });
    }
  };

  const setBranding = async (data) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/set-branding`, data, {
        withCredentials: true,
      });
    } catch (error) {
      console.log("Error setting branding data...", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [teamMembers, setTeamMembers] = useState([]);

  const fetchTeamMembers = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/business-user/teamMembers`,
        { withCredentials: true }
      );
      setTeamMembers(res.data.data.teamMembers);
    } catch (error) {
      console.error("Error fetching team members:", error);
    }
  };

  // Fetch all team members on load
  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const handleInputChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...teamMembers];
    updated[index][name] = value;
    setTeamMembers(updated);
  };

  const [showSaveButton, setShowSaveButton] = useState(false);

  const handleAddNewRow = () => {
    const memberCount = teamMembers.length;
    
    // Fallback safely just in case the plan object structure varies
    const currentPlan = plan?.name || plan?.planName; 

    // 1. Block Starter Plan
    if (currentPlan === "Starter") {
      alert("The Starter plan does not allow adding team members. Please upgrade to Essential or Bloom to build your team.");
      return;
    }

    // 2. Limit Essential Plan
    if (currentPlan === "Essential" && memberCount >= 2) {
      alert("The Essential plan allows a maximum of 2 team members. Please upgrade to Bloom for unlimited team members.");
      return;
    }

    // 3. Allow Bloom Plan (and anyone who passed the checks above)
    setTeamMembers((prev) => [
      ...prev,
      {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        photo: "",
        designation: "",
      },
    ]);
    setShowSaveButton(true);
  };

  const handleSaveAll = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/business-user/editTeamMembers`,
        { teamMembers },
        { withCredentials: true }
      );
      alert("Team members saved successfully!");
      fetchTeamMembers();
      setShowSaveButton(false);
    } catch (error) {
      console.error("Error saving team members:", error);
      alert("Error saving team members.");
    }
  };

  const inputRefs = useRef([]);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleImageButtonClick = (index) => {
    // Trigger the file input click event programmatically
    inputRefs.current[index].click();
  };

  const handleImageUpload = async (index, e) => {
    const file = e.target.files[0];
    setSelectedFile(file); // Store selected file

    if (file) {
      try {
        const formData = new FormData();
        formData.append("profilePic", file); // Append the file to FormData
        formData.append("teamMemberId", teamMembers[index]._id); // Append the team member's ID

        // Sending the data to the backend API
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/team-member/upload-profile`,
          formData,
          { withCredentials: true }
        );

        // Handle the successful response from the API
        alert(response.data.message);
        await fetchTeamMembers();
      } catch (error) {
        console.error("Error uploading image:", error);
        alert("Failed to upload image.");
      }
    }
  };

  const handleDelete = async (teamMemberId) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}/business-user/deleteTeamMember`,
        {
          data: {
            teamMemberId,
          },
          withCredentials: true,
        }
      );
      await fetchTeamMembers();
    } catch (error) {
      console.error("Error deleting team member:", error);
      alert("Error deleting team member.");
    }
  };


  const handleUpdate = () => {
    window.location.href = "https://dashboard.stripe.com/test/settings/payouts";
  };

  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    // const fetchInvoices = async () => {
    //   try {
    //     const res = await axios.get(
    //       `${process.env.REACT_APP_API_URL}/invoices`,
    //       {
    //         withCredentials: true,
    //       }
    //     );
    //     setInvoices(res.data.data);
    //   } catch (err) {
    //     console.error("Error fetching invoices:", err);
    //   }
    // };

    // fetchInvoices();

    const getInvoice = async () => {
      try {

        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/get-invoices/${id}`,
          {
            businessId: id,
          }
        );

        console.log("Invoice generated:", response.data);
        setInvoices(response.data.invoices);
        // contains: message, invoiceUrl, invoice

      } catch (err) {
        const errorMessage =
          err.response?.data?.error || "Failed to generate invoice";
        console.error("Error generating invoice:", errorMessage);
        throw new Error(errorMessage);
      }
    };

    getInvoice();
  }, []);

  const [subscription, setSubscription] = useState(null);
  const [plan, setPlan] = useState(null);
  const [price, setPrice] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const subscriptionRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/business-user/subscription`,
          {
            withCredentials: true,
          }
        );
        const sub = subscriptionRes.data.subscription;
        setSubscription(sub);

        const planRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/plan/${sub?.planName}`,
          {
            withCredentials: true,
          }
        );
        const pl = planRes.data.plan;
        setPlan(pl);

        const calculatedPrice = sub.isYearly ? pl.yearlyCost : pl.monthlyCost;
        setPrice(calculatedPrice);
      } catch (error) {
        console.error("Error fetching subscription or plan:", error);
      }
    };

    fetchData();
  }, []);

  return (
      <div className="account-wrapper" style={{marginTop: "20px"}}>
      <div className="accountInfo">
        <div>
          <h2 style={{ color: "#1C1154", fontWeight: "600", margin: "0" }}>Company</h2>
        </div>
        <div
          className="accountButtons"
          style={{ width: "auto", flexShrink: 0 }}
        >
          <button
            style={{
              height: "40px",
              fontSize: "14px",
              padding: "0 15px",
              background: selectedButton === "account" ? "#2A1980" : "#FFFFFF",
              color: selectedButton === "account" ? "#FFFFFF" : "#1C1154",
              border:
                selectedButton === "account" ? "none" : "1px solid #dedede",
              borderRadius: "6px",
              marginRight: "10px",
              cursor: "pointer",
              fontWeight: selectedButton === "account" ? "normal" : "normal",
            }}
            onClick={() => handleButtonClick("account")}
          >
            Account
          </button>
          <button
            style={{
              height: "40px",
              fontSize: "14px",
              padding: "0 15px",
              background: "#2A1980",
              color: "#FFFFFF",
              border:
                selectedButton === "company" ? "none" : "1px solid #dedede",
              borderRadius: "6px",
              marginRight: "10px",
              cursor: "pointer",
              fontWeight: "normal",
            }}
            onClick={() => handleButtonClick("company")}
          >
            Company
          </button>
          <button
            style={{
              height: "40px",
              minWidth: "130px",
              fontSize: "14px",
              padding: "0 15px",
              background: selectedButton === "booth" ? "#2A1980" : "#FFFFFF",
              color: selectedButton === "booth" ? "#FFFFFF" : "#1C1154",
              border: selectedButton === "booth" ? "none" : "1px solid #dedede",
              borderRadius: "6px",
              cursor: "pointer",
              fontWeight: selectedButton === "booth" ? "600" : "normal",
            }}
            onClick={() => handleButtonClick("booth")}
          >
            Book-A-Booth
          </button>
        </div>
      </div>
      {/* --- COMPANY BRANDING --- */}
      {/* --- COMPANY BRANDING --- */}
      <div
        style={{
          height: "auto",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
          borderRadius: "6px",
        }}
      >
        <h2 style={{ color: "#1C1154", fontWeight: "450", marginBottom: "30px", marginTop: "0" }}>
          Company Branding
        </h2>

        {/* --- ROW 1: Profile Image & Button Color --- */}
        <div className="form-row" style={{ marginBottom: "30px" }}>
          
          {/* 1. Profile Image (UNCHANGED) */}
          <div className="form-col" style={{ display: "flex", gap: "15px", alignItems: "flex-start", }}>
            <img
              src={profileImage || defaultPic}
              alt="Profile"
              style={{ width: "70px", height: "70px", borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
              onError={(e) => { e.target.src = defaultPic; }} 
            />
            <div style={{ display: "flex", flexDirection: "column", width: "100%", position: "relative", marginLeft: "3%" }}>
              <input
                type="file"
                style={{ display: "none" }}
                ref={profileInputRef}
                onChange={handleProfileImageUpload}
              />
              <button
                className="action-btn"
                style={{ height: "40px", fontSize: "14px", borderRadius: "6px",  background: "#FFFFFF", border: "1px solid #D9D9D9", color: "#1C1154", width: "100%", maxWidth: "160px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
                onClick={handleProfileButtonClick}
              >
                <FaUpload /> Profile Image
              </button>
              <div style={{ marginTop: "8px", fontSize: "12px", color: "#625C73" }}>
                Upload png, jpg, or svg images to 256x256 px.
              </div>
              
              {isPrimaryPickerVisible && (
                <div style={{ position: "absolute", top: "50px", left: "0", zIndex: 999, backgroundColor: "white", padding: "20px", borderRadius: "8px", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)" }}>
                  <ColorPicker initialColor={tempColor} onCancel={handleCancel} onChoose={(color) => handleChoose(color, "primary")} />
                </div>
              )}
            </div>
          </div>

          {/* 2. Button Color (UPDATED: alignItems "center", added marginLeft "10%") */}
          <div className="form-col" style={{ display: "flex", gap: "15px", alignItems: "center", paddingLeft: '25%' }}>
            <div
              className="color-preview-circle"
              style={{ backgroundColor: primaryColor, width: "70px", height: "70px", borderRadius: "50%", flexShrink: 0 }}
            />
            <div style={{ display: "flex", flexDirection: "column", width: "100%", marginLeft: "3%" }}>
              <button
                className="action-btn"
                style={{ height: "40px", fontSize: "14px", background: "#FFFFFF", border: "1px solid #D9D9D9", color: "#1C1154", width: "100%", maxWidth: "160px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", borderRadius: "6px" }}
                onClick={togglePrimaryPicker}
              >
                <FaPen /> Button Color
              </button>
            </div>
          </div>
        </div>

        {/* --- ROW 2: Upload Logo & Button Text Color --- */}
        <div className="form-row">
          
          {/* 3. Upload Logo (UNCHANGED) */}
          <div className="form-col" style={{ display: "flex", gap: "15px", alignItems: "flex-start" }}>
            <img
              src={brandLogo || defaultPic}
              alt="Brand Logo"
              style={{ width: "70px", height: "70px", borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
              onError={(e) => { e.target.src = defaultPic; }}
            />
            <div style={{ display: "flex", flexDirection: "column", width: "100%", marginLeft: "3%" }}>
              <input
                type="file"
                style={{ display: "none" }}
                ref={logoInputRef}
                onChange={handleBrandLogoUpload}
              />
              <button
                className="action-btn"
                style={{ height: "40px", fontSize: "14px", borderRadius: "6px",  background: "#FFFFFF", border: "1px solid #D9D9D9", color: "#1C1154", width: "100%", maxWidth: "160px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}
                onClick={handleBrandLogoButtonClick}
              >
                <FaUpload /> Upload Logo
              </button>
              <div style={{ marginTop: "8px", fontSize: "12px", color: "#625C73" }}>
                Upload png, jpg, or svg images to 256x256 px.
              </div>
            </div>
          </div>

          {/* 4. Button Text Color */}
          <div className="form-col" style={{ display: "flex", gap: "15px", alignItems: "flex-start", paddingLeft: "25%" }}>
            <div
              className="color-preview-circle"
              style={{ backgroundColor: secondaryColor, width: "70px", height: "70px", borderRadius: "50%", flexShrink: 0 }}
            />
            <div style={{ display: "flex", flexDirection: "column", width: "100%", position: "relative", marginLeft: "3%", marginTop: "15px" }}>
              <button
                className="action-btn"
                style={{ height: "40px", fontSize: "14px", background: "#FFFFFF", border: "1px solid #D9D9D9", color: "#1C1154", width: "100%", maxWidth: "160px", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", marginBottom: "25px", borderRadius: "6px" }}
                onClick={toggleSecondaryPicker}
              >
                <FaPen /> Button Text Color
              </button>
              
              {/* Sample Button exactly matching screenshot */}
              <button
                className="action-btn"
                style={{ height: "40px", fontSize: "14px", background: primaryColor, border: "1px solid #D9D9D9", color: secondaryColor, borderRadius: "5px", width: "100%", maxWidth: "160px", display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                Button Sample
              </button>

              {/* Color picker moved here for safe z-index overlapping */}
              {isSecondaryPickerVisible && (
                <div style={{ position: "absolute", top: "50px", left: "0", zIndex: 999, backgroundColor: "white", padding: "18px", borderRadius: "8px", boxShadow: "0px 4px 12px rgba(0,0,0,0.15)" }}>
                  <ColorPicker initialColor={tempColor} onCancel={handleCancel} onChoose={(color) => handleChoose(color, "secondary")} />
                </div>
              )}
            </div>
          </div>

        </div>
      </div>

      <div
        style={{
          height: "auto",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px" }}
        >
          Company Info
        </h2>

        <div className="form-row">
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Business Name
            </div>
            <input
              name="name"
              value={companyData?.name}
              onChange={handleChange}
              style={{
                border: "none",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px",
              }}
            />
          </div>
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Website
            </div>
            <input
              name="website"
              value={companyData.website}
              onChange={handleChange}
              style={{
                border: "none",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px",
              }}
            />
          </div>
        </div>

        <div className="form-row">
        <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Email
            </div>
            <input
              name="email"
              value={companyData.email}
              onChange={handleChange}
              style={{
                border: "none",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px",
              }}
            />
          </div>
          <div className="form-col">
            <div
              style={{
                color: "#625C73",
                marginTop: "20px",
                marginBottom: "10px",
                fontSize: "12px",
              }}
            >
              Phone Number
            </div>
            <input
              name="phone"
              value={companyData.phone}
              onChange={handleChange}
              style={{
                border: "none",
                borderBottom: "2px solid #D9D9D9",
                fontSize: "15px",
                width: "100%",
                outline: "none",
                paddingBottom: "5px",
              }}
            />

          </div>
        </div>

        <div>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >

            Street
          </div>
          <input
            name="street"
            value={companyData.street}

            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px",
            }}
          />
        </div>

        <div>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >

            City, State
          </div>
          <input
            name="cityState"
            value={companyData.cityState}
            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px",
            }}
          />
        </div>
        <div>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            Zip Code
          </div>
          <input
            name="zip"
            value={companyData.zip}
            onChange={handleChange}
            style={{
              border: "none",
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              outline: "none",
              paddingBottom: "5px",
            }}
          />
        </div>
        <button
        className="action-btn"
          onClick={handleSave}
          style={{
            marginTop: "30px",
            padding: "10px 20px",
            background: "#260F99",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          Save Details
        </button>
      </div>
      <div
        style={{
          minHeight: "346px",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px" }}
        >
          Team Members
        </h2>

        {teamMembers.map((teamMemberData, index) => (
          <div key={index}>
            <div className="form-row">
              <div className="form-col">
                <div
                  style={{
                    color: "#625C73",
                    marginTop: "20px",
                    marginBottom: "10px",
                    fontSize: "12px",
                  }}
                >
                  First Name
                </div>
                <input
                  name="firstName"
                  value={teamMemberData.firstName}
                  onChange={(e) => handleInputChange(index, e)}
                  style={{
                    border: "hidden",
                    borderBottom: "2px solid #D9D9D9",
                    fontSize: "15px",
                    width: "100%",
                  }}
                />
              </div>

              <div className="form-col">
                <div
                  style={{
                    color: "#625C73",
                    marginTop: "20px",
                    marginBottom: "10px",
                    fontSize: "12px",
                  }}
                >
                  Last Name
                </div>
                <input
                  name="lastName"
                  value={teamMemberData.lastName}
                  onChange={(e) => handleInputChange(index, e)}
                  style={{
                    border: "hidden",
                    borderBottom: "2px solid #D9D9D9",
                    fontSize: "15px",
                    width: "100%",
                  }}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-col">
                <div
                  style={{
                    color: "#625C73",
                    marginTop: "20px",
                    marginBottom: "10px",
                    fontSize: "12px",
                  }}
                >
                  Email
                </div>
                <input
                  name="email"
                  value={teamMemberData.email}
                  onChange={(e) => handleInputChange(index, e)}
                  style={{
                    border: "hidden",
                    borderBottom: "2px solid #D9D9D9",
                    fontSize: "15px",
                    width: "100%",
                  }}
                />
              </div>

              <div className="form-col">
                <div
                  style={{
                    color: "#625C73",
                    marginTop: "20px",
                    marginBottom: "10px",
                    fontSize: "12px",
                  }}
                >
                  Phone Number
                </div>
                <input
                  name="phone"
                  value={teamMemberData.phone}
                  onChange={(e) => handleInputChange(index, e)}
                  style={{
                    border: "hidden",
                    borderBottom: "2px solid #D9D9D9",
                    fontSize: "15px",
                    width: "100%",
                  }}
                />
              </div>
            </div>

            {/* Designation Field */}
            <div className="form-col" style={{ marginTop: "20px" }}>
              <div
                style={{
                  color: "#625C73",
                  marginBottom: "10px",
                  fontSize: "12px",
                }}
              >
                Designation
              </div>
              <input
                name="designation"
                value={teamMemberData.designation}
                onChange={(e) => handleInputChange(index, e)}
                style={{
                  border: "hidden",
                  borderBottom: "2px solid #D9D9D9",
                  fontSize: "15px",
                  width: "100%",
                }}
              />
            </div>

            {/* Show photo upload only if the member is saved */}
            {teamMemberData._id && (
              <div style={{ display: "flex", marginTop: "35px" }}>
                <img
                  src={teamMemberData?.photoUrl || defaultPic}
                  alt="Profile"
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    objectFit: "cover" // Ensures the image isn't squished
                  }}
                  onError={(e) => { e.target.src = defaultPic; }} 
                />
                <div
                  className="accountButtons"
                  style={{
                    gap: "17px",
                    marginLeft: "4%",
                    width: "100%",
                    alignItems: "center",
                    flexWrap: "wrap"
                  }}
                >
                  <input
                    type="file"
                    style={{ display: "none" }}
                    ref={(el) => (inputRefs.current[index] = el)}
                    onChange={(e) => handleImageUpload(index, e)}
                  />
                  <button
                  className="action-btn"
                    style={{
                      width: "20%",
                      height: "40px",
                      fontSize: "14px",
                      background: "#FFFFFF",
                      border: "1px solid #D9D9D9",
                      color: "#1C1154",
                    }}
                    onClick={() => handleImageButtonClick(index)}
                  >
                    <FaUpload /> Upload Photo
                  </button>
                  <button
                  className="action-btn"
                    style={{
                      width: "30%",
                      height: "40px",
                      fontSize: "14px",
                      background: "#F2F2F2",
                      border: "1px solid #D9D9D9",
                      color: "#1C1154",
                    }}
                    onClick={() => handleDelete(teamMemberData._id)}
                  >
                    <FaTrash /> Delete Team Member
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}

        <div style={{ display: "flex", gap: "20px", marginTop: "20px" }}>
          {!showSaveButton ? (
            <button
              className="addTeamMemberButton action-btn"
              id="team-members"
              ref={teamRef}
              style={{ height: "40px", width: "25%", minWidth: "160px" }}
              onClick={handleAddNewRow}
            >
              Add Team Member
            </button>
          ) : (
            <button
              className="addTeamMemberButton action-btn"
              style={{ height: "40px", width: "25%", minWidth: '160px' }}
              onClick={handleSaveAll}
            >
              Save Details
            </button>
          )}
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
      >
        <h2 style={{ color: "#1C1154", fontWeight: "450", marginBottom: "50px" }}>
          Membership
        </h2>
        
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "15px" }}>
          {/* Default to 'Starter' if no planName is returned from Stripe */}
          <h4 style={{ color: "#1C1154" }}>
            {billingInfo?.subscription?.planName || "Starter"}
          </h4>
          <button
          className="action-btn"
            onClick={openModal}
            style={{
              height: "40px",
              fontSize: "14px",
              background: "#FFFFFF",
              color: "#1C1154",
              border: "1px solid #D9D9D9",
              cursor: "pointer",
            }}
          >
            Change Plan
          </button>
        </div>

        <ProductModal
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          setIsModalOpen={setIsModalOpen}
          setIsCancelModalOpen={setIsCancelModalOpen}
          isCancelModalOpen={isCancelModalOpen}
        />
        
        <CancelMembershipModal
          isCancelModalOpen={isCancelModalOpen}
          closeCancelModal={() => {
            setIsCancelModalOpen(false);
          }}
        />

        <div style={{ color: "#625C73", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h5>3% credit card or 1.5% ACH fee.</h5>
          
          {/* Show the price, or default to Free/Trial if no amount exists */}
          {billingInfo.subscription?.amount > 0 
            ? `$${billingInfo?.subscription?.amount}/${billingInfo.subscription.interval}` 
            : "Free Trial"}
        </div>

        <h5 style={{ color: "#625C73", fontSize: "15px" }}>
          {/* Smart logic to handle Trial Dates vs Next Payment Dates */}
          {billingInfo.subscription?.status === 'trialing' && billingInfo.subscription?.trialEnd ? (
             `Trial ends on: ${new Date(billingInfo.subscription.trialEnd).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" })}`
          ) : billingInfo.subscription?.nextPaymentDate ? (
             `Next payment: $${billingInfo.subscription.amount} on ${new Date(billingInfo.subscription.nextPaymentDate).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" })}`
          ) : (
             "No payment method on file. Trial active."
          )}
        </h5>
      </div>
      <div
        style={{
          height: "230px",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "35px" }}
        >
          Billing
        </h2>
        <div
          style={{
            color: "#625C73",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h4>Payment Method</h4>
          Credit Card
        </div>
        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >
            {" "}
            Card Number
          </div>
          <input
            // Use the Stripe card data!
            placeholder={billingInfo.paymentMethod ? `•••• •••• •••• ${billingInfo.paymentMethod.last4}` : "No card on file"}
            disabled
            style={{ border: "hidden", borderBottom: "2px solid #D9D9D9", fontSize: "15px", width: "100%", backgroundColor: "#fff" }}
          />
        </div>
      </div>

      <div
        style={{
          height: "auto",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
      >
        <h2 style={{ marginTop: "30px", color: "#1C1154", fontWeight: "450" }}>
          Invoice History
        </h2>
        <div>
          {/* --- TABLE HEADER --- */}
          <div
            style={{
              color: "#625C73",
              display: "flex",
              justifyContent: "space-between",
              padding: "15px 0", // Cleaned up padding for better alignment
              borderBottom: "1px solid #D9D9D9",
              fontSize: "14px",
            }}
          >
            <div style={{ width: "25%", paddingLeft: "10px" }}>Date</div>
            <div style={{ width: "35%" }}>Plan</div>
            <div style={{ width: "20%" }}>Amount</div>
            <div style={{ width: "20%", textAlign: "center" }}>Download Invoice</div>
          </div>

          {/* --- TABLE DATA ROWS --- */}
          {billingInfo?.invoices?.length > 0 ? (
            billingInfo?.invoices?.map((invoice, index) => (
              <div 
                key={index} 
                style={{ 
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center", // Vertically centers the text with the download icon
                  padding: "15px 0",
                  borderBottom: "1px solid #D9D9D9",
                  color: "#1C1154", // Primary text color matching Membership
                  fontSize: "15px"
                }}
              >
                {/* Date (Secondary color) */}
                <div style={{ width: "25%", color: "#625C73", paddingLeft: "10px" }}>
                  {new Date(invoice.issuedDate).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" })}
                </div>
                
                {/* Plan Name (Primary color, slightly bolder) */}
                <div style={{ width: "35%", fontWeight: "500" }}>
                  {invoice.planName}
                </div>
                
                {/* Amount (Primary color) */}
                <div style={{ width: "20%" }}>
                  ${invoice.total.toFixed(2)}
                </div>
                
                {/* Download Icon */}
                <div
                  style={{ 
                    width: "20%", 
                    textAlign: "center", 
                    cursor: "pointer", 
                    fontSize: "18px", 
                    color: "#2A1980" // Standout purple from your buttons
                  }}
                  onClick={() => window.open(invoice.invoiceUrl, "_blank")}
                >
                  <ImDownload3 />
                </div>
              </div>
            ))
          ) : (
             <div style={{ padding: "20px 10px", color: "#625C73", fontSize: "15px" }}>
               No invoice history found.
             </div>
          )}
        </div>
      </div>

      <div
        style={{
          height: "380px",
          backgroundColor: "#FFFFFF",
          marginBottom: "20px",
          padding: "6%",
          paddingTop: "5%",
        }}
        ref={bankRef}
        id="bank-info"
      >
        <h2
          style={{ color: "#1C1154", fontWeight: "450", marginBottom: "25px" }}
        >
          Bank Info
        </h2>


        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >

            Business Type
          </div>
          <p
            style={{
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              margin: 0,
              paddingBottom: "5px",
              color: "#000000",
            }}
          >
            {bankData?.businessType || "N/A"}
          </p>

        </div>

        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >

            Bank Account
          </div>
          <p
            style={{
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              margin: 0,
              paddingBottom: "5px",
              color: "#000000",
            }}
          >
            ********{bankData?.bankAccNo || ""}
          </p>

        </div>

        <div style={{ width: "100%" }}>
          <div
            style={{
              color: "#625C73",
              marginTop: "20px",
              marginBottom: "10px",
              fontSize: "12px",
            }}
          >

            Business Owner
          </div>
          <p
            style={{
              borderBottom: "2px solid #D9D9D9",
              fontSize: "15px",
              width: "100%",
              margin: 0,
              paddingBottom: "5px",
              color: "#000000",
            }}
          >
            {typeof bankData?.businessOwner === "string"
              ? bankData.businessOwner
              : ""}
          </p>

        </div>

        <button
          onClick={handleUpdate}
          className="action-btn"
          style={{
            marginTop: "35px",
            height: "40px",
            background: "#FFFFFF",
            border: "1px solid #D9D9D9 ",
            color: "#1C1154",
            fontSize: "17px",
            fontWeight: "450",

            cursor: "pointer",
          }}
        >
          Update Bank Info

        </button>
      </div>
    </div>
  );
};

export default CompanyInfo;
